import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';

import {
  Form,
  PrimaryButton,
  FieldSelect,
  FieldTextInput,
} from '../../../components';

import css from './ReportListingModal.module.css';

const ReportListingForm = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        handleSubmit,
        inProgress = false,
        listingTitle,
      } = fieldRenderProps;

      const intl = useIntl();

      const reasonLabel = intl.formatMessage({
        id: 'ReportListingModal.reasonLabel',
        defaultMessage: 'Why are you reporting this?',
      });
      const detailsLabel = intl.formatMessage({
        id: 'ReportListingModal.detailsLabel',
        defaultMessage: 'Details',
      });
      const detailsPlaceholder = intl.formatMessage({
        id: 'ReportListingModal.detailsPlaceholder',
        defaultMessage: 'Please describe what is suspicious or inaccurate about this listing…',
      });
      const detailsRequired = validators.requiredAndNonEmptyString(
        intl.formatMessage({
          id: 'ReportListingModal.detailsRequired',
          defaultMessage: 'Please provide details about your report.',
        })
      );
      const emailLabel = intl.formatMessage({
        id: 'ReportListingModal.emailLabel',
        defaultMessage: 'Your email address',
      });
      const emailPlaceholder = intl.formatMessage({
        id: 'ReportListingModal.emailPlaceholder',
        defaultMessage: 'Enter your email for follow-up…',
      });

      const classes = classNames(rootClassName || css.form, className);

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <FieldSelect
            id="reportReason"
            name="reason"
            label={reasonLabel}
            className={css.field}
          >
            <option value="scam">
              {intl.formatMessage({
                id: 'ReportListingModal.reasonScam',
                defaultMessage: 'Suspected scam, fake ad, or deposit fraud',
              })}
            </option>
            <option value="stolen">
              {intl.formatMessage({
                id: 'ReportListingModal.reasonStolen',
                defaultMessage: 'Suspected stolen bike (no title or VIN)',
              })}
            </option>
            <option value="inaccurate">
              {intl.formatMessage({
                id: 'ReportListingModal.reasonInaccurate',
                defaultMessage: 'Inaccurate specs, price, or bait-and-switch',
              })}
            </option>
            <option value="prohibited">
              {intl.formatMessage({
                id: 'ReportListingModal.reasonProhibited',
                defaultMessage: 'Prohibited or hazardous item',
              })}
            </option>
            <option value="other">
              {intl.formatMessage({
                id: 'ReportListingModal.reasonOther',
                defaultMessage: 'Other safety / policy concern',
              })}
            </option>
          </FieldSelect>

          <FieldTextInput
            className={css.field}
            type="textarea"
            name="details"
            id="reportDetails"
            label={detailsLabel}
            placeholder={detailsPlaceholder}
            validate={detailsRequired}
          />

          <FieldTextInput
            className={css.field}
            type="email"
            name="email"
            id="reportEmail"
            label={emailLabel}
            placeholder={emailPlaceholder}
          />

          <PrimaryButton
            type="submit"
            inProgress={inProgress}
            disabled={inProgress}
            className={css.submitButton}
          >
            <FormattedMessage
              id="ReportListingModal.submit"
              defaultMessage="Submit report"
            />
          </PrimaryButton>
        </Form>
      );
    }}
  />
);

export default ReportListingForm;
